import { render, staticRenderFns } from "./Images.html?vue&type=template&id=72c316b0&scoped=true&"
import script from "./Images.js?vue&type=script&lang=js&"
export * from "./Images.js?vue&type=script&lang=js&"
import style0 from "./Images.scss?vue&type=style&index=0&id=72c316b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c316b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
